module.exports = __webpack_public_path__ + "static/humi-logo-40fc546d6bd35c374524e3267f76440c.png";